
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useAppDispatch, useAppSelector } from '../../hooks/hooks';
import { selectUploadFileCreatedItem, selectUploadFileQueryItems } from '../../redux/upload-files/selector';
import storePersist from '../../redux/storePersist';
import { uploadFiles } from '../../redux/upload-files/action';

export const MobileFileUploadComponent = ({ handleFileURlSubmit, folder, ownerId }: any) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [preview, setPreview] = useState(null);
    var tenantId = storePersist?.get("accessTokenMetadata")?.current?.TokenMetadata?.TenantId;
    const dispatch = useAppDispatch();
    const currentFile = useAppSelector(selectUploadFileCreatedItem)
    const queryFile = useAppSelector(selectUploadFileQueryItems)

    const [
        selectedFileSRC,
        setSelectedFileSRC
    ] = useState<any>()

    const handleFileSubmit = async (data) => {
        const frmData = new FormData();
        const type = data?.type.split("/")[0];
        const fileType = type === "image" ? "image" : "document";
        frmData.append(
            'DigiiFolderName',
            folder
        )
        frmData.append(
            'DigiiDocTypeName',
            fileType
        )
        frmData.append(
            'SubFolderName',
            ''
        )
        frmData.append(
            'OwnerId',
            ownerId
        )
        frmData.append(
            'TenantId',
            tenantId || 0
        )
        frmData.append(
            'documents',
            data
        )
        await dispatch(uploadFiles.resetAction({ actionType: 'create' }))
        await dispatch(uploadFiles.create({
            url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dms/digii-docs`,
            entity: 'uploadFiles',
            jsonData:
                frmData
        }))
    }

    useEffect(() => {
        if (currentFile?.isSuccess) {
            fetchFile(currentFile?.result)
        }
    }, [currentFile])

    const fetchFile = async (id: any) => {
        await dispatch(uploadFiles.resetAction({ actionType: 'query' }))
        await dispatch(uploadFiles.query({
            url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dms/digii-docs/query`,
            entity: 'uploadFiles',
            jsonData: {
                Records: [{
                    Context: {},
                    Message: {
                        TenantId: tenantId,
                        Id: id
                    }
                }

                ]
            }
        }))
        await dispatch(uploadFiles.resetAction({ actionType: 'create' }))
    }

    useEffect(() => {
        if (queryFile?.isSuccess) {
            setSelectedFileSRC({
                FileType: queryFile?.result?.items?.DocumentType,
                DocumentPath: queryFile?.result?.items?.DocumentPath
            })

        }
    }, [queryFile])

    const handleSubmit = (event: any) => {
        const file = event.target.files[0];
        handleFileSubmit(file);

        if (file) {
            setSelectedFile(file);

            // Check if the file is an image format
            if (file.type.startsWith("image/")) {
                setPreview(URL.createObjectURL(file));
            } else {
                setPreview(null);
            }
        }
    };

    const handleUploadSubmit = () => {
        handleFileURlSubmit(selectedFileSRC)
        dispatch(uploadFiles.resetAction({ actionType: 'query' }))
    }

    return (
        <div>
            <div className="flex flex-col items-center justify-center w-full pt-2 px-2 sm:px-4">
                <label
                    htmlFor="dropzone-file"
                    className="flex flex-col items-center justify-center w-full h-32 sm:h-36 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                >
                    <div className="flex flex-col items-center justify-center pt-4 pb-5 text-center">
                        <svg
                            className="w-6 h-6 sm:w-8 sm:h-8 mb-3 text-gray-500"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 20 16"
                        >
                            <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                            />
                        </svg>
                        <p className="mb-1 text-xs sm:text-sm text-gray-500">
                            <span className="font-semibold">Tap to Upload E-Way Bill</span> or drag & drop
                        </p>
                        <p className="text-xs text-gray-500">CSV, PDF, SVG, PNG, JPG, GIF</p>
                    </div>
                    <input id="dropzone-file" type="file" className="hidden" accept=".csv,.pdf,.svg,.png,.jpg,.jpeg,.gif" onChange={handleSubmit} />
                </label>

                {selectedFile && (
                    <div className="mt-3 p-2 border rounded-lg w-full max-w-sm text-center">
                        <div className="text-sm font-medium">Preview</div>
                        {preview ? (
                            <img src={preview} alt="Preview" className="max-h-32 sm:max-h-40 mx-auto rounded-lg" />
                        ) : (
                            <div>
                                <p className="text-xs sm:text-sm text-gray-700">Selected: {selectedFile.name}</p>
                                <p className="text-xs text-gray-500">Type: {selectedFile.type}</p>
                            </div>
                        )}
                    </div>
                )}
            </div>
            <div className="flex justify-center sm:justify-end space-x-2 sm:space-x-4 mt-4 sm:mt-6">
                <button
                    disabled={!queryFile?.isSuccess}
                    onClick={handleUploadSubmit}
                    className={`px-3 py-1.5 sm:px-4 sm:py-2 text-sm sm:text-base bg-primary text-light rounded-md ${queryFile?.isSuccess ? 'bg-primary hover:bg-slate-500' : 'bg-slate-500'}`}
                >
                    Upload
                </button>
            </div>
        </div>

    )
}
export default MobileFileUploadComponent;
